module.exports = __webpack_public_path__ + "img/10-en.361045e9.png";